<template>
  <div class="row d-flex flex-row h-100">
    <auth-left-container> </auth-left-container>
    <div
      class="right-container bg-extra-light-gray p-4 d-flex flex-column justify-content-center align-items-center text-black"
    >
      <div class="center-form">
        <h2 class="mb-4" style="font-weight: bold;">
          Forgot <span class="text-primary">Password</span>
        </h2>
        <form class="form-action" @submit.prevent="submitForgot">
          <b-form-group
            :invalid-feedback="error"
            :state="error.length == 0"
            style="margin-top: 35px;"
          >
            <b-form-input
              v-model="email"
              placeholder="Enter your email"
              class="auth-input bigger-input"
            ></b-form-input>
          </b-form-group>
          <b-button
            type="submit"
            variant="primary"
            class="auth-button w-100"
            style="margin-top: 20px;"
            >Reset</b-button
          >
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import serverAuth from "../../server/auth";
import { validateRequired, validateEmail } from "../../helpers/validation";
import AuthLeftContainer from "./AuthLeftContainer.vue";

export default {
  name: "AuthForgotPassword",
  components: {
    AuthLeftContainer
  },
  data() {
    return {
      email: "",
      error: ""
    };
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    validateForgot() {
      let withoutErrors = true;

      this.error = "";
      if (!validateRequired(this.email)) {
        this.error = "This field is required";
        withoutErrors = false;
      } else if (!validateEmail(this.email)) {
        this.error = "You must provide a valid email format";
        withoutErrors = false;
      }
      return withoutErrors;
    },
    async submitForgot() {
      this.error = "";
      const result = await this.validateForgot();
      if (result) {
        const forgotResult = await serverAuth.forgotPassword(this.email);
        if (forgotResult.errorCode) this.error = forgotResult.message;
        else {
          this.showAlertSuccess();
          this.$router.push("/reset-code");
        }
      }
    }
  }
};
</script>
<style scoped>
.right-container {
  width: 50%;
}
.center-form {
  padding: 0px 15%;
}
.form-action {
  max-width: 400px;
  min-width: 400px;
}
</style>
